import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { Catalog } from '@/types/catalog';

interface CatalogTableProps {
  catalogs: Catalog[];
  onDelete: (id: number) => void;
  onRestore: (id: number) => void;
  onViewDetails: (catalogId: number) => void;
}

export function CatalogTable({
  catalogs,
  onDelete,
  onRestore,
  onViewDetails,
}: CatalogTableProps) {
  if (catalogs.length === 0) {
    return (
      <div className="py-8 text-center text-muted-foreground">
        No catalogs found. Create your first catalog to get started.
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead>Description</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Stacks</TableHead>
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {catalogs.map((catalog) => (
          <TableRow key={catalog.id}>
            <TableCell className="font-medium">{catalog.name}</TableCell>
            <TableCell>{catalog.description}</TableCell>
            <TableCell>
              <Badge variant={catalog.is_active ? 'default' : 'destructive'}>
                {catalog.is_active ? 'Active' : 'Deleted'}
              </Badge>
            </TableCell>
            <TableCell>{catalog.stacks_count}</TableCell>
            <TableCell className="text-right">
              {catalog.is_active ? (
                <div className="flex justify-end gap-2">
                  <Button size="sm" variant="outline" onClick={() => onViewDetails(catalog.id)}>
                    View Details
                  </Button>
                  <Button
                    size="sm"
                    variant="destructive"
                    onClick={() => onDelete(catalog.id)}
                  >
                    Delete
                  </Button>
                </div>
              ) : (
                <Button size="sm" variant="outline" onClick={() => onRestore(catalog.id)}>
                  Restore
                </Button>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}